import { RequestCommonParams, handleRequestError } from '@jove-frontend/uikit';
import { api } from '@jove-frontend/uikit';
import { convertBytes, formatCommonDateStr } from '@jove-frontend/uikit';
import qs from 'qs';

const handleUserDocumentItem = (item) => {
  return {
    ...item,
    // title: aItem?.revision?.filename?.replace('.pdf', ''),
    title: item?.revision?.filename,
    fullTitle: item?.revision?.filename,
    url: item?.url,
    fileSizeText: convertBytes(item?.revision?.byte_size).MB,
    updateTimeText: formatCommonDateStr(item?.revision?.updated_at),
    id: item?.document?.id,
    revisionId: item?.revision?.id,
  };
};

// get user documents
export const apiGetUserAllDocuments = async (payload: { user_id?: string } & RequestCommonParams) => {
  try {
    const res = await api.get(`/client/policies/documents?${qs.stringify(payload)}`);

    const newMap = {};
    for (const [key, list] of Object.entries(res?.data || {})) {
      const newList = [];
      ((list || []) as Array<any>).forEach((item) => {
        item.documents = (item.documents || []).map((aItem) => {
          return handleUserDocumentItem(aItem);
        });
        item.invoice_documents = (item.invoice_documents || []).map((aItem) => {
          return handleUserDocumentItem(aItem);
        });
        newList.push(item);
      });
      newMap[key] = newList;
    }

    res.data = newMap;

    return [res.data];
  } catch (err) {
    return handleRequestError(err, payload);
  }
};

// get payment schedule
export const apiGetPaymentScheduleInfo = async (
  payload: {
    provider_code?: string;
    year?: string | number;
    user_id?: string;
  } & RequestCommonParams
) => {
  try {
    const res = await api.get(`/policies/client/billing-schedule?${qs.stringify(payload)}`);

    return [res.data];
  } catch (err) {
    return handleRequestError(err, payload);
  }
};

// Get document info
export const apiGetPolicyDocumentDetailInfo = async (payload: { revision_id: string } & RequestCommonParams) => {
  try {
    const res = await api.get(`/documents/${payload?.revision_id}`, {
      responseType: 'blob',
    });
    return res;
  } catch (err) {
    return handleRequestError(err, payload);
  }
};
